<div #myEl>
  <h2 mat-dialog-title>{{title}}</h2>
  <mat-dialog-content>
    <form mat-dialog-content class="forms-sample">


      <div id="inputEmail" class="form-group">
        <label for="exampleinputEmail"></label>
        <input [(ngModel)]="value" name="email" type="text" class="form-control" id="exampleinputEmail" placeholder="{{valueName}}">
      </div>

    </form>
  </mat-dialog-content>

  <mat-dialog-actions align="end">
    <div class="container">
      <button   (click)="send(true)" cdkFocusInitial type="submit" class="btn btn-gradient-primary mb-3 mr-2">Підтвердити</button>
      <button (click)="send(false)" class="btn mr-2 mb-3 btn-gradient-info btn-light">Закрити</button></div>
  </mat-dialog-actions>

</div>
